import { InterpolatableTranslationObject, TranslateService } from '@ngx-translate/core';
import { DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { firstValueFrom } from 'rxjs';

const STORAGE_KEY_LANGUAGE = "backoffice-language";
const supportedLanguages = ['pl', 'en', 'ro'];

export function languageInitializer(): Promise<InterpolatableTranslationObject> {
  const translateService = inject(TranslateService);
  const destroyRef: DestroyRef = inject(DestroyRef);
  translateService.addLangs(supportedLanguages);

  let language: string | null = localStorage.getItem(STORAGE_KEY_LANGUAGE) ?? translateService.getBrowserLang() ?? translateService.getFallbackLang() ?? "pl";
  if (!supportedLanguages.includes(language)) {
    language = translateService.getFallbackLang() ?? "pl";
  }

  translateService.onLangChange.pipe(
    takeUntilDestroyed(destroyRef)
  ).subscribe((lang) => localStorage.setItem(STORAGE_KEY_LANGUAGE, lang.lang));

  return firstValueFrom(translateService.use(language));
}
